import { Injectable } from '@angular/core';
import {ExcRestService} from 'exc-rest';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ModalAuditCancelComponent} from './modals/modal-audit-cancel/modal-audit-cancel.component';
import {Observable} from 'rxjs';
import {ModalYesNoComponent} from './modals/modal-yes-no/modal-yes-no.component';
import {ModalAuditPinChangedComponent} from './modals/modal-audit-pin-changed/modal-audit-pin-changed.component';
import {ModalAuditExtendComponent} from './modals/modal-audit-extend/modal-audit-extend.component';
import {ExcTab} from 'exc-tab';
import {AuditDetailsComponent} from './audit-details/audit-details.component';
import {ModalCommentComponent} from './modals/modal-comment/modal-comment.component';
import {ModalResendCodeComponent} from './modals/modal-resend-code/modal-resend-code.component';
import {ModalNewAuditComponent} from './modals/modal-new-audit/modal-new-audit.component';
import {DefaultSettingsService} from './default-settings-service.service';
import {ModalEditSelfcheckComponent} from './modals/modal-edit-selfcheck/modal-edit-selfcheck.component';
import {ProviderModalNewAuditComponent} from './provider/modals/provider-modal-new-audit/provider-modal-new-audit.component';
import {ModalAuditReopenComponent} from './modals/modal-audit-reopen/modal-audit-reopen.component';

@Injectable({
  providedIn: 'root'
})
export class  AuditActionService extends ExcTranslation {

  constructor(private excRest: ExcRestService, private excDss: DefaultSettingsService) {
    super();
  }

  public Open(AuditID: number, Audit: any) {
    new ExcTab(AuditID.toString(), AuditDetailsComponent, Audit, AuditID.toString(), {
      Unique: true, ReloadParent: function () {
        // _self.initialLoad();
      }
    }, true).Open();
  }
  public RemoteClose(AuditID: number, currentItems: number, totalItems: number) {
    const _self = this;
    console.log('Start adopt Result.');
    const obs: Observable<AuditActionResult> = Observable.create( o => {
      ExcCoreModule.showModal(ModalYesNoComponent, null, 'xs', {Message: _self.getRessource('CloseScHint', {current: currentItems, total: totalItems, percent: (currentItems / totalItems * 100)})}, false).subscribe( r => {
        if (r && r.proceed === true) {
          _self.excRest.post(_self.excRest.computeUrl('AuditU_RemoteClose', {AuditID: AuditID}), {}, {}).subscribe(ret => {
            o.next(new AuditActionResult(AuditID, true));
            o.complete();
          });
        } else {
          o.next(new AuditActionResult(AuditID, false));
          o.complete();
        }
      });
    });
    return obs;
  }
  // 20250224DL : RP-769 - add adoptResult
  public adoptResult(AuditID: number, currentItems: number, totalItems: number) {
    const _self = this;
    const obs: Observable<AuditActionResult> = Observable.create( o => {
      ExcCoreModule.showModal(ModalYesNoComponent, null, 'xs', {Message: _self.getRessource('ClosePartialResultHint', {current: currentItems, total: totalItems, percent: (currentItems / totalItems * 100)})}, false).subscribe( r => {
        if (r && r.proceed === true) {
          _self.excRest.post(_self.excRest.computeUrl('AuditU_ApplyResults', {AuditID: AuditID}), {}, {}).subscribe(ret => {
            o.next(new AuditActionResult(AuditID, true));
            o.complete();
          });
        } else {
          o.next(new AuditActionResult(AuditID, false));
          o.complete();
        }
      });
    });
    return obs;
  }
  public SelfcheckComment(AuditID: number, Comment?: string) {
    const _self = this;
    const obs: Observable<AuditActionResult> = Observable.create( o => {
      ExcCoreModule.showModal(ModalCommentComponent, null, 'm', {Header: _self.getRessource('ScComment'), Comment: Comment || null, CommentLabel: ' '}, false).subscribe( r => {
        if (r && r.proceed === true) {
          _self.excRest.post(_self.excRest.computeUrl('AuditU_ScComment', {AuditID: AuditID}), {Comment: r.Comment}, {}).subscribe(ret => {
            o.next(new AuditActionResult(AuditID, true,  ret.data[0]));
            o.complete();
          });
        } else {
          o.next(new AuditActionResult(AuditID, false));
          o.complete();
        }
      });
    });
    return obs;
  }
  public AuditMdtComment(AuditID: number, Comment?: string) {
    const _self = this;
    const obs: Observable<AuditActionResult> = Observable.create( o => {
      ExcCoreModule.showModal(ModalCommentComponent, null, 'm', {Header: _self.getGlobal('CommentAudit'), Comment: Comment || null, CommentLabel: _self.getGlobal('SupportHashtags')}, false).subscribe( r => {
        if (r && r.proceed === true) {
          _self.excRest.post(_self.excRest.computeUrl('AuditU_AuditMdtComment', {AuditID: AuditID}), {AuditMdtComment: r.Comment}, {}).subscribe(ret => {
            o.next(new AuditActionResult(AuditID, true,  ret.data[0]));
            o.complete();
          });
        } else {
          o.next(new AuditActionResult(AuditID, false));
          o.complete();
        }
      });
    });
    return obs;
  }
  public Edit(AuditID: number, Audit: any) {
    const _self = this;
    const data = {};
    data['AuditType'] = Audit['AuditType'];
    data['AuditID'] = Audit['AuditID'];
    data['AuditMonth'] = Audit['AuditMonth'];
    data['AuditYear'] = Audit['AuditYear'];
    data['AuditSelfcheckAnnounceDate'] = Audit['AuditSelfcheckAnnounceDate'];
    data['AuditSelfcheckValidFrom'] = Audit['AuditSelfcheckValidFrom'];
    data['AuditSelfcheckValidTo'] = Audit['AuditSelfcheckValidTo'];
    data['AuditSelfcheckQuota'] = Audit['AuditSelfcheckQuota'];
    data['AuditSelfcheckMinimum'] = Audit['AuditSelfcheckMinimum'];
    data['AuditSelfcheckMaximum'] = Audit['AuditSelfcheckMaximum'];
    data['AuditSelfcheckHours'] = Audit['AuditSelfcheckHours'];
    data['AuditMdtComment'] = Audit['AuditMdtComment'];
    data['AuditIsPicked'] = Audit['AuditIsPicked'];
    data['ScPickedStock'] = Audit['ScPickedStock'];
    data['AuditUPT'] = Audit['AuditUPT'];
    data['ScAnnounced'] = Audit['ScAnnounced'];
    data['ScFixedToHour'] = Audit['ScFixedToHour'];
    data['ScFixedFromHour'] = Audit['ScFixedFromHour'];
    data['ScFixedDuration'] = Audit['ScFixedDuration'];
    data['ScSendMailHour'] = Audit['ScSendMailHour'];
    data['ScSendMailHour'] = Audit['ScSendMailHour'];
    const obs: Observable<any> = Observable.create( o => {
      let modalComponent: any = null;
      if (data['AuditType'] === 16 || data['AuditType'] === 35) {
        modalComponent = ModalEditSelfcheckComponent;
      } else {
        modalComponent = null; // ModalEditFloorcheckComponent;
      }
      ExcCoreModule.showModal(modalComponent, null, 'l', data, false, null).subscribe(response => {
        if (response.proceed === true) {
          let url = '';
          if (data['AuditType'] === 16 || data['AuditType'] === 35) {
            url = _self.excRest.computeUrl('AuditU_Selfcheck', {AuditID: data['AuditID']});
          } else {
            url = _self.excRest.computeUrl('AuditU_Floorcheck', {AuditID: data['AuditID']});
          }
          _self.excRest.post(url, response.Audit, {}).subscribe(r => {
            if (r) {
              o.next(r);
              o.complete();
            } else {
              o.next(r);
              o.complete();
            }
          });
        }
      });
    });
    return obs;
  }
  public Create(DealerHeader: any, Auditors: any[] = null, preselected: {items: any[], mode: string} = null, isFirstCall: boolean = true, addMore: boolean = false) {
    const _self = this;
    const data = {};
    data['DefaultAuditType'] = this.excDss.MandantSettings['DefaultAuditType'];
    data['DefaultObjectCheck'] = DealerHeader['DealerObjectCheck'];
    data['DefaultDocumentCheck'] = DealerHeader['DealerDocumentCheck'];
    data['DealerID'] = DealerHeader['DealerID'];
    data['DealerResponsibleLevel2'] = DealerHeader['DealerResponsibleLevel2'];
    data['DealerResponsibleLevel3'] = DealerHeader['DealerResponsibleLevel3'];
    data['Preselected'] = preselected;
    data['DealerEmail'] = DealerHeader['DealerEmail'];
    data['ScAnnounced'] = DealerHeader['ScAnnounced'];
    data['ScFixedToHour'] = DealerHeader['ScFixedToHour'];
    data['ScFixedFromHour'] = DealerHeader['ScFixedFromHour'];
    data['ScFixedDuration'] = DealerHeader['ScFixedDuration'];
    data['ScSendMailHour'] = DealerHeader['ScSendMailHour'];
    data['Auditors'] = Auditors || [];
    const obs: Observable<AuditActionResult> = Observable.create( o => {
      data['IsFirstCall'] = isFirstCall;
      data['AddMore'] = addMore;
        ExcCoreModule.showModal(ModalNewAuditComponent, null, 'xl', data, false, null).subscribe(response => {
          if (response.proceed === true) {
            data['IsFirstCall'] = false;
            data['AddMore'] = addMore;

            let url = '';
            addMore = response.addMore;
            if (response.Audit.Type === 'SC') {
              url = _self.excRest.computeUrl('AuditC_Selfcheck', {DealerID: DealerHeader['DealerID']});
            } else {
              url = _self.excRest.computeUrl('AuditC_Floorcheck', {DealerID: DealerHeader['DealerID']});
            }
            _self.excRest.put(url, response.Audit.Data, {}, false).subscribe(r => {
              if (r) {
                o.next(new AuditActionResult(r.AuditID, true, {AuditFollowup: response.Audit.Data.AuditFollowup}));
                if (response.addMore === true) {
                  this.Create(data, Auditors, preselected, false, true).subscribe(r2 => {});
                } else {
                  o.complete();
                }
              } else {
                o.next(new AuditActionResult(r.AuditID, false));
                o.complete();

              }
            });
          }
        });
    });
    return obs;
  }
  public ProviderCreate(DealerHeader: any, preselected: {items: any[], mode: string} = null, isFirstCall: boolean = true, addMore: boolean = false) {
    const _self = this;
    const data = {};
    data['DefaultAuditType'] = this.excDss.MandantSettings['DefaultAuditType'];
    data['DefaultObjectCheck'] = DealerHeader['DealerObjectCheck'];
    data['DefaultDocumentCheck'] = DealerHeader['DealerDocumentCheck'];
    data['DealerID'] = DealerHeader['DealerID'];
    data['DealerResponsibleLevel2'] = DealerHeader['DealerResponsibleLevel2'];
    data['DealerResponsibleLevel3'] = DealerHeader['DealerResponsibleLevel3'];
    data['Preselected'] = preselected;
    data['DealerEmail'] = DealerHeader['DealerEmail'];
    const obs: Observable<AuditActionResult> = Observable.create( o => {
      data['IsFirstCall'] = isFirstCall;
      data['AddMore'] = addMore;
      ExcCoreModule.showModal(ProviderModalNewAuditComponent, null, 'l', data, false, null).subscribe(response => {
        if (response.proceed === true) {
          data['IsFirstCall'] = false;
          data['AddMore'] = addMore;
          let url = '';
          addMore = response.addMore;
          if (response.Audit.Type === 'SC') {
            url = _self.excRest.computeUrl('AuditC_Selfcheck', {DealerID: DealerHeader['DealerID']});
          } else {
            url = _self.excRest.computeUrl('AuditC_Floorcheck', {DealerID: DealerHeader['DealerID']});
          }
          _self.excRest.put(url, response.Audit.Data, {}, false).subscribe(r => {
            if (r) {
              o.next(new AuditActionResult(r.AuditID, true));
              if (response.addMore === true) {
                this.ProviderCreate(data, preselected, false, true).subscribe(r2 => {});
              } else {
                o.complete();
              }
            } else {

              // o.next(new AuditActionResult(r.AuditID, false));
              o.complete();

            }
          });
        }
      });
    });
    return obs;
  }
  public Cancel(AuditID: number) {
    const _self = this;
    const obs: Observable<AuditActionResult> = Observable.create( o => {
      ExcCoreModule.showModal(ModalAuditCancelComponent, null, 'm', {}, false).subscribe( r => {
        if (r && r.proceed === true) {
          _self.excRest.post(_self.excRest.computeUrl('AuditU_Cancel', {AuditID: AuditID}), {Comment: r.Comment, CancellationReason: r.cancelReason}, {}).subscribe(ret => {
            o.next(new AuditActionResult(AuditID, true));
            o.complete();
          });
        } else {
          o.next(new AuditActionResult(AuditID, false));
          o.complete();
        }
      });
    });
    return obs;
  }
  public Extend(AuditID: number) {
    const _self = this;
    const obs: Observable<AuditActionResult> = Observable.create(o => {
      ExcCoreModule.showModal(ModalAuditExtendComponent, null, 'm', {}, false).subscribe(r => {
        if (r && r.proceed === true) {
          _self.excRest.post(_self.excRest.computeUrl('AuditU_Extend', {AuditID: AuditID}), {
            Comment: r.Comment,
            Hours: typeof r.Extension === 'string' ? parseInt(r.Extension, 10) : r.Extension
          }, {}).subscribe(ret => {
            o.next(new AuditActionResult(AuditID, true));
            o.complete();
          });
        } else {
          o.next(new AuditActionResult(AuditID, false));
          o.complete();
        }
      });
    });
    return obs;
  }
  public Reopen(AuditID: number) {
    const _self = this;
    const obs: Observable<AuditActionResult> = Observable.create(o => {
      ExcCoreModule.showModal(ModalAuditReopenComponent, null, 'm', {isReopen: true}, false).subscribe(r => {
        if (r && r.proceed === true) {
          _self.excRest.post(_self.excRest.computeUrl('AuditU_Reopen', {AuditID: AuditID}), {
            Comment: r.Comment,
            Hours: typeof r.Extension === 'string' ? parseInt(r.Extension, 10) : r.Extension
          }, {}).subscribe(ret => {
            o.next(new AuditActionResult(AuditID, true));
            o.complete();
          });
        } else {
          o.next(new AuditActionResult(AuditID, false));
          o.complete();
        }
      });
    });
    return obs;
  }
  public ChangePin(AuditID: number) {
    const _self = this;
    const obs: Observable<AuditActionResult> = Observable.create( o => {
      ExcCoreModule.showModal(ModalYesNoComponent, null, 'xs', {Message: _self.getRessource('ResetPinHint')}, false).subscribe( r => {
        if (r && r.proceed === true) {
          _self.excRest.post(_self.excRest.computeUrl('AuditU_Pin', {AuditID: AuditID}), {}, {}).subscribe(ret => {
            ExcCoreModule.showModal(ModalAuditPinChangedComponent, null, 'xs', {Pin: ret.data[0].NewPin, TriesLeft: ret.data[0].PinTriesLeft}, false).subscribe(x => {
              o.next(new AuditActionResult(AuditID, true));
              o.complete();
            });
          });
        } else {
          o.next(new AuditActionResult(AuditID, false));
          o.complete();
        }
      });
    });
    return obs;
  }
  public ResendCode(AuditID: number, DealerMail: string) {
    const _self = this;
    const obs: Observable<AuditActionResult> = Observable.create( o => {
      ExcCoreModule.showModal(ModalResendCodeComponent, null, 's', {DealerMail: DealerMail}, false).subscribe( r => {
        if (r && r.proceed === true) {
          _self.excRest.post(_self.excRest.computeUrl('AuditU_Resend', {AuditID: AuditID}), {Mail: r.Mail}, {}).subscribe(ret => {
            o.next(new AuditActionResult(AuditID, true));
            o.complete();
          });
        } else {
          o.next(new AuditActionResult(AuditID, false));
          o.complete();
        }
      });
    });
    return obs;
  }
  public Escalate(AuditID: number) {
    const _self = this;
    const obs: Observable<AuditActionResult> = Observable.create( o => {
      ExcCoreModule.showModal(ModalCommentComponent, null, 'm', {Header: _self.getRessource('EscalateHeader')}, false).subscribe( r => {
        if (r && r.proceed === true) {
          _self.excRest.post(_self.excRest.computeUrl('AuditU_Escalate', {AuditID: AuditID}), {Comment: r.Comment}, {}).subscribe(ret => {
              o.next(new AuditActionResult(AuditID, true));
              o.complete();
          });
        } else {
          o.next(new AuditActionResult(AuditID, false));
          o.complete();
        }
      });
    });
    return obs;
  }
  public EscalationAction(AuditID: number) {

  }
  public Archive(AuditID: number) {
    const _self = this;
    const obs: Observable<AuditActionResult> = Observable.create( o => {
      ExcCoreModule.showModal(ModalCommentComponent, null, 'm', {Header: _self.getRessource('ArchiveHeader')}, false).subscribe( r => {
        if (r && r.proceed === true) {
          _self.excRest.post(_self.excRest.computeUrl('AuditU_Archive', {AuditID: AuditID}), {Comment: r.Comment}, {}).subscribe(ret => {
            o.next(new AuditActionResult(AuditID, true));
            o.complete();
          });
        } else {
          o.next(new AuditActionResult(AuditID, false));
          o.complete();
        }
      });
    });
    return obs;
  }
}
export class AuditActionResult {
  public get AuditID() {return this._auditID; }
  private _auditID: number;
  public get Result() {return this._result; }
  private _result: boolean;
  public get Data() {return this._data; }
  private _data: any;
  constructor(AuditID: number, Result: boolean, Data?: any) {
    this._auditID = AuditID;
    this._result = Result;
    this._data = Data || null;
  }
}
